import React, { forwardRef, useState } from 'react';
import InputMask from 'react-input-mask';
import { Input } from 'reactstrap';

const RG = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || '');
    const [error, setError] = useState(props.error || '');
    let className = '';

    const handleChange = (element) => {
        let elementValue = element.target.value;
        const isValidRG = validateRG(elementValue);

        if (elementValue.length === 12 && isValidRG) {
            elementValue = '';
        }

        setValue(elementValue);
        setError(isValidRG ? '' : 'RG inválido');
        props.onChange(element);
    };

    const validateRG = (rg) => {
        return /^\d{9}$/.test(rg);
    };

    if (props.error) {
        className = 'is-invalid';
    }

    return (
        <div  ref={ref}>
            <Input
                type="text"
                mask="99.999.999-9"
                maskChar=""
                tag={InputMask}
                className={className}
                id={`id_${props.name}`}
                name={props.name}
                onChange={handleChange}
                value={value}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus || false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
})

export default RG;
